module.exports = __webpack_public_path__ + "static/thumb-drones-b728aee6ce980f091a0ea5ca67638063.png";